import { Injectable } from '@angular/core';

import { Escalation } from 'src/models';

import { GenericObjectsService } from './generic-objects.service';

@Injectable({
  providedIn: 'root',
})
export class EscalationsService extends GenericObjectsService<Escalation> {
  protected override baseUrl = '/escalations';
}
